import Guid from '@/app/utils/guid'
import Entity from './entity'
import moment from 'moment'

export default abstract class NodeEntity extends Entity {

  public name: string = ''
  public keywords: string[] = []
}
